var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"column-float"},[(_vm.row.numeroGuiaReembolso)?_c('span',{staticClass:"title"},[_vm._v(_vm._s(_vm.column.title))]):_vm._e(),_c('span',{staticClass:"preco"},[_vm._v(_vm._s(_vm.price))])])
}
var staticRenderFns = []

export { render, staticRenderFns }